import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, switchMap, tap } from 'rxjs/operators'

import { AuthService } from '../services/auth/auth.service'

@Injectable()
export class AuthGuardWithForcedLogin {
	constructor(private authService: AuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authService.isDoneLoading$.pipe(
			filter((isDone) => isDone),
			switchMap((_) => this.authService.isAuthenticated$),
			tap((isAuthenticated) => isAuthenticated || this.authService.login(state.url)),
		)
	}
}
